// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo1 {
    width: 100px; 
    height: 75px;
}

.Menu1 {
    width: 100%;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 20px;

}

.nav-link {
    color: #006cb5;
    font-weight: bolder;
    margin-left: 25px;
    font-size: medium;
   
}

.footer {
    max-width: 100%;
    height: auto;
    width: 100vw;
}

.carrocel {
    max-width: 100%;
    height: auto;
    width: 100vw;
}

.LogoNova {
    width: 15%;
}

.LogoFooter {
    width: 10%;
    
}

.Footer {
    
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    
    max-width: 100%;
    height: auto;
    width: 100vw;
  }


  @media (max-width: 768px) {
    .carrocel img {
      height: 250px;
    }
  }
  
  @media (max-width: 576px) {
    .carrocel img {
      height: 150px;
    }
  }









  





`, "",{"version":3,"sources":["webpack://./src/Pages/Components/components.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;;AAErB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;;AAEd;;AAEA;;IAEI,eAAe;IACf,OAAO;IACP,SAAS;IACT,WAAW;;IAEX,eAAe;IACf,YAAY;IACZ,YAAY;EACd;;;EAGA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF","sourcesContent":[".logo1 {\n    width: 100px; \n    height: 75px;\n}\n\n.Menu1 {\n    width: 100%;\n    font-family: 'Nunito Sans', sans-serif;\n    font-size: 20px;\n\n}\n\n.nav-link {\n    color: #006cb5;\n    font-weight: bolder;\n    margin-left: 25px;\n    font-size: medium;\n   \n}\n\n.footer {\n    max-width: 100%;\n    height: auto;\n    width: 100vw;\n}\n\n.carrocel {\n    max-width: 100%;\n    height: auto;\n    width: 100vw;\n}\n\n.LogoNova {\n    width: 15%;\n}\n\n.LogoFooter {\n    width: 10%;\n    \n}\n\n.Footer {\n    \n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    \n    max-width: 100%;\n    height: auto;\n    width: 100vw;\n  }\n\n\n  @media (max-width: 768px) {\n    .carrocel img {\n      height: 250px;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .carrocel img {\n      height: 150px;\n    }\n  }\n\n\n\n\n\n\n\n\n\n  \n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
